import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import actions from '../../../actions';

export const usePromptStepService = () => {
  const dispatch = useDispatch();

  const handleClose = useCallback(() => {
    dispatch(actions.setModalStep(null));
  }, [dispatch]);

  const benefits = [
    {
      emoji: '1️⃣',
      titleKey: 'pwaModal.step1.title',
      descriptionKey: 'pwaModal.step1.description',
    },
    {
      emoji: '2️⃣',
      titleKey: 'pwaModal.step2.title',
      descriptionKey: 'pwaModal.step2.description',
    },
    {
      emoji: '3️⃣',
      titleKey: 'pwaModal.step3.title',
      descriptionKey: 'pwaModal.step3.description',
    },
  ];

  return { benefits, handleClose };
};
